import './AdTagsLegend.scss';

import { bem } from 'mission-control-common-components';

import { AD_TAGS_LEGEND_CONTENT_ITEMS, AD_TAGS_LEGEND_TITLE } from './constants';

const [block, element] = bem('ad-tags-legend');

const AdTagsLegend = (): React.JSX.Element => {
  return (
    <div className={block()} data-testid="ad-tags-legend">
      <div className={element('title')}>{AD_TAGS_LEGEND_TITLE}</div>
      <div className={element('content-wrapper')}>
        {AD_TAGS_LEGEND_CONTENT_ITEMS.map(({ id, icon, label }) => (
          <div className={element('content-item')} key={id}>
            {icon}
            <div>{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdTagsLegend;
